module.exports = __webpack_public_path__ + "img/Treasure Mania.e1f2710b.jpg";